import * as React from "react";
import { forwardRef } from "react";
const SvgGlyphBack = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M28,16a1,1,0,0,1-1,1H10v3.18933a.75.75,0,0,1-1.28033.5304L4.53033,16.53027a.74984.74984,0,0,1,0-1.06054l4.18934-4.18946A.75.75,0,0,1,10,11.81067V15H27A1,1,0,0,1,28,16Z" }));
const ForwardRef = forwardRef(SvgGlyphBack);
export default ForwardRef;
